
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCustomerSurveyGrid extends Serenity.EntityGrid<ReportCustomerSurveyRow, any> {
        protected getColumnsKey() { return ReportCustomerSurveyColumns.columnsKey; }
        protected getDialogType() { return ReportCustomerSurveyDialog; }
        protected getIdProperty() { return ReportCustomerSurveyRow.idProperty; }
        protected getInsertPermission() { return ReportCustomerSurveyRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportCustomerSurveyRow.localTextPrefix; }
        protected getService() { return ReportCustomerSurveyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }


        protected getButtons() {
            var buttons = super.getButtons();

             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'refresh-button'), 1)
             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
             
             //buttons.push(send);


             // Add buttons import excel, pdf
             buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                 grid: this,
                 service: ReportCustomerSurveyService.baseUrl + '/ListExcel',
                 onViewSubmit: () => this.onViewSubmit(),
                 separator: true
             }));

             buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRyReportCustomerSurvey/edit/131';
                        return false;
                    },
                }
            );


            return buttons;
        }
    }
}